import $ from 'jquery'
import fullpage from 'fullpage.js/dist/fullpage.extensions.min'

const initFp = () => {
    if (!document.body.classList.contains('page-template-page-landing')) {
        return false
    }
    const blocks = $('.vn-block')
    blocks.each(function () {
        $(this).addClass('section');
    });

    $('.site-footer').appendTo($('.landing-blocks'))
    $('.site-footer').addClass('section');

    window.fp = new fullpage('#fullpage', {
        licenseKey: 'J2GL9-4KD97-PKRT7-6W6JK-MYFCM',
        autoScrolling: true,
        responsiveSlidesKey:
            'aDRkbWx6YVc5dWMyNXZkWFpsYkd4bGN5NWpiMjA9anZfcHZuY21WemNHOXVjMmwyWlZOc2FXUmxjdz09YnI4',
        responsiveSlides: true,
    });

    window.dispatchEvent(new Event('resize'))
    window.fp.reBuild()
    return window.fp
}

window.addEventListener('load', initFp)

$('.go-top').on('click', function () {
    if (
        window.matchMedia('(max-width: 991px)').matches ||
        !$('body').hasClass('page-template-page-landing')
    ) {
        document
            .getElementsByTagName('html')[0]
            .scrollIntoView({ behavior: 'smooth' })
    } else {
        window.fp.moveTo(1)

        // Reset horizontal container
        const slidesContainer = $('.fp-slidesContainer')
        slidesContainer.find('.active').removeClass('active')
        slidesContainer.find('>:first-child').addClass('active')
        slidesContainer.css('transform', 'translate3d(0px, 0px, 0px)')
    }
})


$('.js-landing-mouse').on('click', function () {
    window.fp.moveSectionDown();
})
